(() => {
  const desktopQuery = window.matchMedia('(min-width: 990px)');
  const transitionDuration = 400;

  const closeMegaMenu = (details) => {
    if (!details || !details.hasAttribute('open')) return;

    details.classList.remove('is-open');
    details.classList.add('is-closing');

    window.clearTimeout(details._closeTimer);

    details._closeTimer = window.setTimeout(() => {
      details.removeAttribute('open');
      details.classList.remove('is-closing');
    }, transitionDuration);
  };

  const openMegaMenu = (details) => {
    if (!details || !desktopQuery.matches) return;

    document.querySelectorAll('.header__inline-menu details.mega-menu').forEach((item) => {
      if (item !== details) {
        closeMegaMenu(item);
      }
    });

    window.clearTimeout(details._closeTimer);

    details.setAttribute('open', '');
    details.classList.remove('is-closing');

    window.requestAnimationFrame(() => {
      details.classList.add('is-open');
    });
  };

  const closeAllMegaMenus = () => {
    document.querySelectorAll('.header__inline-menu details.mega-menu[open]').forEach((details) => {
      closeMegaMenu(details);
    });
  };

  const initMegaMenuHover = () => {
    const megaMenus = document.querySelectorAll('.header__inline-menu details.mega-menu');

    megaMenus.forEach((details) => {
      if (details.dataset.hoverReady === 'true') return;
      details.dataset.hoverReady = 'true';

      const summary = details.querySelector('summary');

      let openTimer;
      let closeTimer;

      details.addEventListener('pointerenter', () => {
        if (!desktopQuery.matches) return;

        window.clearTimeout(closeTimer);
        window.clearTimeout(openTimer);

        openTimer = window.setTimeout(() => {
          openMegaMenu(details);
        }, 120);
      });

      details.addEventListener('pointerleave', (event) => {
        if (!desktopQuery.matches) return;

        const nextElement = event.relatedTarget;

        if (nextElement && details.contains(nextElement)) {
          return;
        }

        window.clearTimeout(openTimer);
        window.clearTimeout(closeTimer);

        closeTimer = window.setTimeout(() => {
          closeMegaMenu(details);
        }, 180);
      });

      if (summary) {
        summary.addEventListener('click', (event) => {
          if (!desktopQuery.matches) return;

          event.preventDefault();

          window.clearTimeout(openTimer);
          window.clearTimeout(closeTimer);

          if (details.classList.contains('is-open')) {
            closeMegaMenu(details);
          } else {
            openMegaMenu(details);
          }
        });

        summary.addEventListener('focus', () => {
          if (!desktopQuery.matches) return;

          openMegaMenu(details);
        });
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeAllMegaMenus();
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenuHover);
  } else {
    initMegaMenuHover();
  }
})();